import React from 'react';
import { MapPin } from 'lucide-react';
export function ServiceArea() {
  const areas = ['Far East El Paso', 'Horizon City', 'Socorro', 'Clint', 'Fabens'];
  return <section className="py-20 bg-white border-y border-gray-100" data-id="element-240">
      <div className="container mx-auto px-4" data-id="element-241">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-12" data-id="element-242">
          <div className="lg:w-1/2 text-center lg:text-left" data-id="element-243">
            <span className="text-brand-green font-semibold tracking-wider uppercase text-sm mb-3 block" data-id="element-244">
              Where We Serve
            </span>
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-brand-navy mb-6" data-id="element-245">
              Proudly Serving Far East El Paso
            </h2>
            <p className="text-lg text-gray-600 font-body mb-8 max-w-xl mx-auto lg:mx-0" data-id="element-246">
              Trusted cleaning for homes and businesses across Far East El Paso
              and the surrounding communities.
            </p>

            <div className="flex flex-wrap justify-center lg:justify-start gap-3" data-id="element-247">
              {areas.map((area, index) => <div key={index} className="flex items-center px-5 py-2.5 bg-gray-50 border border-gray-200 rounded-full text-gray-700 font-medium" data-id="element-248">
                  <MapPin className="w-4 h-4 mr-2 text-brand-green" data-id="element-249" />
                  {area}
                </div>)}
            </div>
          </div>

          <div className="lg:w-1/2 w-full max-w-lg" data-id="element-250">
            <div className="aspect-video bg-gray-100 rounded-3xl overflow-hidden relative shadow-inner border border-gray-200" data-id="element-251">
              {/* Stylized Map Graphic Placeholder */}
              <div className="absolute inset-0 opacity-50" style={{
              backgroundImage: 'radial-gradient(#cbd5e1 1px, transparent 1px)',
              backgroundSize: '20px 20px'
            }} data-id="element-252"></div>
              <div className="absolute inset-0 flex items-center justify-center flex-col" data-id="element-253">
                <MapPin className="w-16 h-16 text-brand-green mb-4 drop-shadow-md" data-id="element-254" />
                <div className="px-6 py-3 bg-white rounded-2xl shadow-lg border border-gray-100 text-brand-navy font-bold text-lg" data-id="element-255">
                  Far East El Paso
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}